import { jsx as _jsx } from "react/jsx-runtime";
import { antdMessage } from '@hellodarwin/core/lib/features/providers/antd-app-provider';
import { GinStepItemFieldType, InitialGinStepApplicationItem, } from '@hellodarwin/core/lib/features/entities/gin-step-entities';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Drawer from 'antd/es/drawer';
import { useState } from 'react';
import GinStepBucketAssetUploadForm from './gin-step-bucket-asset-upload-form';
const GinStepBucketAssetEditorDrawer = ({ open, isLoading: isApplicationItemLoading, title, onClose, itemId, formApplicationId, applicationItem, operations, downloadAsset, relatedFilesTitle, flattenRelatedFiles, onSuccess, }) => {
    const { t } = useTranslations();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isLoading = isApplicationItemLoading || isSubmitting;
    const bucket = applicationItem === null || applicationItem === void 0 ? void 0 : applicationItem.asset_bucket_application;
    const uploadNewAsset = (file, name, bucketApplicationId, folderName) => {
        const request = {
            file_name: name || file.name,
            file_description: '',
            asset_id: '',
            version: '',
            gin_step_item_id: itemId,
            gin_asset_bucket_application_id: bucketApplicationId,
            folder_name: folderName,
            records: (bucket === null || bucket === void 0 ? void 0 : bucket.item_asset_bucket_application_id)
                ? [
                    {
                        record_id: bucket.item_asset_bucket_application_id,
                        record_type: 'gin_asset_bucket_item',
                    },
                    {
                        record_id: operations.assets.programId,
                        record_type: 'application_item',
                    },
                ]
                : [
                    {
                        record_id: operations.assets.programId,
                        record_type: 'application_item',
                    },
                ],
        };
        return operations.assets.uploadApplicationAsset(request, file);
    };
    const handleSaveAssets = async (fileSubmission) => {
        var _a, _b, _c;
        const bucketApplicationId = (bucket === null || bucket === void 0 ? void 0 : bucket.item_asset_bucket_application_id) || crypto.randomUUID();
        setIsSubmitting(true);
        try {
            const assets = [];
            for (const file of fileSubmission.new_files) {
                assets.push(await uploadNewAsset(file, fileSubmission.new_display_names[file.uid] || file.name, bucketApplicationId, fileSubmission.bucket_name));
            }
            for (const file of fileSubmission.assets_to_copy) {
                const request = {
                    asset_id: file.asset_id,
                    file_name: (_c = (_b = (_a = fileSubmission.assets_to_copy_display_names[file.asset_id]) !== null && _a !== void 0 ? _a : file.display_name) !== null && _b !== void 0 ? _b : file.file_name) !== null && _c !== void 0 ? _c : '',
                    file_description: '',
                    version: '',
                    gin_step_item_id: itemId,
                    gin_asset_bucket_application_id: bucketApplicationId,
                    folder_name: fileSubmission.bucket_name,
                    records: [
                        {
                            record_id: operations.assets.programId,
                            record_type: 'application_item',
                        },
                        {
                            record_id: bucketApplicationId,
                            record_type: 'gin_asset_bucket_item',
                        },
                    ],
                };
                assets.push(await operations.assets.copyApplicationAsset(request));
            }
            for (const file of fileSubmission.old_files) {
                const asset = Object.assign(Object.assign({}, file), { display_name: fileSubmission.old_display_names[file.asset_id] });
                if (fileSubmission.old_display_names[file.asset_id] !== file.display_name) {
                    await operations.assets.renameApplicationAsset(asset);
                }
                assets.push(asset);
            }
            if (fileSubmission.assets_to_delete.length > 0) {
                await operations.assets.deleteApplicationAssets(fileSubmission.assets_to_delete, operations.assets.programId, bucket === null || bucket === void 0 ? void 0 : bucket.item_asset_bucket_application_id);
            }
            if (assets.length === 0) {
                await (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
                return;
            }
            const newApplicationItem = Object.assign(Object.assign({}, (applicationItem || InitialGinStepApplicationItem)), { item_application_id: (applicationItem === null || applicationItem === void 0 ? void 0 : applicationItem.item_application_id) || '', item_id: itemId, form_application_id: formApplicationId, field_type: GinStepItemFieldType.ASSET_BUCKET, asset_bucket_application: {
                    item_asset_bucket_application_id: bucketApplicationId,
                    item_id: itemId,
                    bucket_name: fileSubmission.bucket_name,
                    file_uploads: undefined,
                    file_responses: assets,
                } });
            const isUpdate = !!applicationItem;
            const form = await operations.submitApplicationItem(newApplicationItem, isUpdate, false);
            if (!isUpdate && form.program_status_trigger) {
                operations.triggerProgramStatusDialog(form.program_status_trigger);
            }
            await (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
        }
        catch (error) {
            console.error(error);
            antdMessage.error(t('gin_steps|step_asset_create_error'));
        }
        finally {
            setIsSubmitting(false);
        }
    };
    const handleDownloadAsset = async (oldFile, uploadedFile) => {
        if (oldFile) {
            try {
                const response = await downloadAsset(oldFile.asset_id);
                if (response === null || response === void 0 ? void 0 : response.link) {
                    window.open(response.link, 'download');
                }
                else {
                    console.error('Download URL not found.');
                }
            }
            catch (error) {
                console.error('Failed to download asset:', error);
            }
            return;
        }
        if (uploadedFile) {
            const blob = new Blob([uploadedFile], {
                type: uploadedFile.type || 'application/octet-stream',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = uploadedFile.name || 'download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    };
    return (_jsx(Drawer, { title: title, placement: "right", width: 500, closable: !isLoading, maskClosable: !isLoading, open: open, onClose: () => {
            if (!isLoading)
                onClose();
        }, children: _jsx(GinStepBucketAssetUploadForm, { handleAfterFinish: onClose, handleSaveAssets: handleSaveAssets, assets: bucket === null || bucket === void 0 ? void 0 : bucket.file_responses, handleDownloadAsset: handleDownloadAsset, isDrawerOpen: open, isLoading: isLoading, bucketName: bucket === null || bucket === void 0 ? void 0 : bucket.bucket_name, fetchRelatedAssets: operations.assets.fetchGinStepApplicationRelatedAssets, relatedFilesTitle: relatedFilesTitle, flattenRelatedFiles: flattenRelatedFiles }) }));
};
export default GinStepBucketAssetEditorDrawer;
